import { render, staticRenderFns } from "./personcenter.vue?vue&type=template&id=274ab936&scoped=true&"
import script from "./personcenter.vue?vue&type=script&lang=js&"
export * from "./personcenter.vue?vue&type=script&lang=js&"
import style0 from "./personcenter.vue?vue&type=style&index=0&id=274ab936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ab936",
  null
  
)

export default component.exports